import { WatchFunnelService } from './../../../../services/watch-funnel.service';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WatchAccountService } from '../../../../services/watch-account.service';
import {
  IFunnel,
  IFunnelStepVariation,
  IInbox,
  ICandidate,
  Document,
} from '../../../../interfaces/graph-types';
import { AccountService } from '../../../../services/account.service';
import { FunnelService } from '../../../../services/funnel.service';
import { Subscription, Subject } from 'rxjs';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalCandidateSelectorComponent } from '../../../modals/candidate-selector/modal-candidate-selector.component';

@Component({
  selector: '[account-funnel-mission-control]',
  template: require('./account-funnel-mission-control.component.pug'),
  styles: [
    require('./account-funnel-mission-control.component.css').toString(),
  ],
})
export class AccountFunnelMissionControlComponent {
  sub: Subscription = null;
  subInboxes: Subscription = null;
  subsubject: Subscription = null;

  inboxes: IInbox[] = [];

  funnel: IFunnel = null;
  testRequested = false;

  @Input()
  subject: Subject<boolean>;

  selectedVariations: IFunnelStepVariation[] = [];
  selectedInbox: IInbox = null;
  selectedCandidate: ICandidate = null;

  accountId: string;

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private watchAccount: WatchAccountService,
    private watchFunnel: WatchFunnelService,
    private accountService: AccountService,
    private funnelService: FunnelService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.subsubject = this.subject.subscribe(next => {
      if (next) {
        this.openBulk();
      } else {
        this.closeBulk();
      }
    });
    this.accountId = this.watchAccount.accountId().getValue();
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.subsubject) {
      this.subsubject.unsubscribe();
    }
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.subInboxes) {
      this.subInboxes.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  hideAvatar(company) {
    company.avatarUrl = null;
  }

  bottomHeight = '-100%';
  sliderOpened = false;

  // -------------------------------------------------------------------
  closeBulk() {
    this.bottomHeight = '-100%';
    this.sliderOpened = false;
  }

  loadingInboxes = true;

  // -------------------------------------------------------------------
  openBulk() {
    this.loadingInboxes = true;
    this.funnel = null;
    this.bottomHeight = '0';
    this.sliderOpened = true;
    this.selectedVariations = [];
    this.selectedInbox = null;
    this.selectedCandidate = null;
    this.emailsSent = false;

    if (this.subInboxes) {
      this.subInboxes.unsubscribe();
    }

    this.inboxes = [];
    this.subInboxes = this.funnelService
      .inboxes(this.watchFunnel.funnelId().getValue())
      .subscribe(funnel => {
        if (funnel) {
          this.loadingInboxes = false;
          funnel.allInboxes.forEach(element => {
            if (element.assigned) {
              if (!this.selectedInbox) {
                this.selectedInbox = element;
              }
              this.inboxes.push(element);
            }
          });
        }
      });

    if (this.sub) {
      this.sub.unsubscribe();
    }

    this.sub = this.accountService
      .funnel(this.watchFunnel.funnelId().getValue())
      .subscribe(funnel => {
        if (funnel) {
          funnel.steps.forEach(element => {
            this.selectedVariations.push(element.variations[0]);
          });
        }

        this.funnel = funnel;
      });
  }

  bsModalRef: BsModalRef;

  // -------------------------------------------------------------------
  pickCandidate(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    // modal for picking a test candidate
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      accountId: this.watchAccount.accountId().getValue(),
      onSelect: this.onCandidateSelectedForVisuaization.bind(this),
      onSuccess: onsuccess,
      onFailure: onfailure,
    };

    this.bsModalRef = this.modalService.show(
      ModalCandidateSelectorComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  emailsSent = false;

  // -------------------------------------------------------------------
  sendTestEmails(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    let variationIds = [];
    this.selectedVariations.forEach(element => {
      variationIds.push(element.id);
    });

    this.funnelService.sendTestEmails(
      this.watchFunnel.funnelId().getValue(),
      this.selectedCandidate.id,
      this.selectedInbox.id,
      variationIds,
      () => {
        this.emailsSent = true;
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  onCandidateSelectedForVisuaization(
    candidate: ICandidate,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.selectedVariations = [];
    this.selectedCandidate = candidate;
    this.funnel = null;

    let inboxId = null;
    if (this.selectedInbox) {
      inboxId = this.selectedInbox.id;
    }

    let candidateId = null;
    if (this.selectedCandidate) {
      candidateId = this.selectedCandidate.id;
    }

    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.accountService
      .resolveFunnel(
        this.watchFunnel.funnelId().getValue(),
        candidateId,
        inboxId,
      )
      .subscribe(funnel => {
        if (funnel) {
          funnel.steps.forEach(element => {
            this.selectedVariations.push(element.variations[0]);
          });

          // onsuccess();
          this.funnel = funnel;
        }
      });

    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  public trackByDocumentId(index: number, doc: Document): Document['id'] {
    return doc.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  inboxSelected(
    inbox: IInbox,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.selectedVariations = [];
    this.funnel = null;
    this.selectedInbox = inbox;

    let inboxId = null;
    if (inbox) {
      inboxId = inbox.id;
    }

    let candidateId = null;
    if (this.selectedCandidate) {
      candidateId = this.selectedCandidate.id;
    }

    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.accountService
      .resolveFunnel(
        this.watchFunnel.funnelId().getValue(),
        candidateId,
        inboxId,
      )
      .subscribe(funnel => {
        if (funnel) {
          funnel.steps.forEach(element => {
            this.selectedVariations.push(element.variations[0]);
          });

          onsuccess();
          this.funnel = funnel;
          this.selectedInbox = inbox;
        }
      });
  }

  // -------------------------------------------------------------------
  getHeight(nbVariations) {
    //return '100px';
    return (nbVariations * 25).toString() + 'px';
  }

  // -------------------------------------------------------------------
  liveButtonText() {
    if (this.funnel.live) {
      return 'Pause Funnel';
    } else {
      return 'Go Live!';
    }
  }

  // -------------------------------------------------------------------
  setLive(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let newvalue = !this.funnel.live;

    this.funnelService.setLive(
      this.watchFunnel.funnelId().getValue(),
      newvalue,
      () => {
        this.funnel.live = newvalue;
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
